import { useState } from "react";
import _ from "lodash";
import { useDispatch } from "react-redux";
import { useAlert } from "react-alert";

import * as React from "react";

import * as Sentry from "@sentry/browser";

import { Delete } from "@material-ui/icons";

import { makeRequest } from "../../../util";
import { fetchEventDefs } from "../../../actions/eventDefs";

import MenuButton from "../../../components/MenuButton";
import { RemoveEventsModal } from "./modals/RemoveEventsModal";

import { LoadedEventDefinition } from "../../../types/global";
import { ButtonType } from "../../../components/MenuButton/types";

interface RemoveEventsMenuProps {
  allEvents: LoadedEventDefinition[];
  selectedEvents: string[];
  onClearSelection: () => void;
}
export function RemoveEventsMenu({
  allEvents,
  selectedEvents,
  onClearSelection,
}: RemoveEventsMenuProps) {
  const dispatch = useDispatch();
  const alert = useAlert();
  const [modalOpen, setModalOpen] = useState<Boolean>(false);

  function handleSave() {
    const eventsById = _.keyBy(allEvents, (e) => e.id);

    const [toHide, toDelete] = _.partition(
      selectedEvents,
      (id) => eventsById[id]?.is_hidden
    );

    makeRequest("bulk_remove_events", {
      hide_event_def_ids: toHide,
      delete_event_def_ids: toDelete,
    })
      .then(() => {
        let msg = "";
        if (toDelete.length && toHide.length) {
          msg = `Deleted ${toDelete.length} event${
            toDelete.length > 0 && "s"
          } and hidden ${toHide.length} event${toHide.length > 0 && "s"}.`;
        } else if (toDelete.length) {
          msg = `Deleted ${toDelete.length} event${
            toDelete.length > 0 && "s"
          }.`;
        } else if (toHide.length) {
          msg = `Hidden ${toHide.length} event${toHide.length > 0 && "s"}`;
        }
        alert.info(msg);
        onClearSelection();
        dispatch(fetchEventDefs());
        setModalOpen(false);
      })
      .catch((error) => {
        console.log(error);
        Sentry.captureException(error);
        alert.error("Something went wrong. Unable to remove events.");
      });
  }

  return (
    <>
      {modalOpen && (
        <RemoveEventsModal
          numSelectedEvents={selectedEvents.length}
          onClose={() => setModalOpen(false)}
          onSave={handleSave}
        />
      )}
      <MenuButton
        showArrow={false}
        menuID="delete-events-modal"
        label="Delete Events"
        onClick={() => setModalOpen(true)}
        startIcon={<Delete />}
        type={ButtonType.Error}
      />
    </>
  );
}
